import React, { useState, useEffect } from "react";
import LojaService from "../../services/LojaService";
import Loja from "../../components/Loja/Loja";
import { useDispatch, useStore } from "react-redux";
import { ActionCreators } from "../../_actions/ActionCreators";
import Modal from "../../components/FlexFreteModal/Modal";
import { useHistory } from "react-router-dom";
import DelimitadorDeCards from "../../utils/DelimitadorDeCards";
import { MinhasLojasPageStyle, LojaContainerStyle } from "./style";

const lojaService = new LojaService();

function MinhasLojas() {
  const delimitaCards = new DelimitadorDeCards();
  const modal = useStore().getState().modal;
  const dispatch = useDispatch();
  const history = useHistory();

  const [processando, setProcessando] = useState(false);
  const [minhasLojas, setMinhasLojas] = useState([]);
  const [erro, setErro] = useState({
    isWrong: false,
    titulo: "",
    mensagem: "",
  });
  const [sucesso, setSucesso] = useState({
    isSuccess: modal,
    titulo: "",
    mensagem: "Operação realizada com sucesso!",
  });

  useEffect(() => {
    if (!processando) {
      setProcessando(true);
      lojaService.obterLojas((erro, sucesso) => {
        if (erro) {
          setErro({
            isWrong: true,
            mensagem:
              "Erro ao obter lista de lojas, entre em contato com o suporte ou tente novamente mais tarde.",
          });
          return;
        }
        if (sucesso) {
          setMinhasLojas(sucesso);
        }
      });
    }
  }, [processando]);

  let lojasColumns = delimitaCards.arrayChunks(minhasLojas, 2);

  const todasaslojas = lojasColumns.map((items, index) => {
    return (
      <div className="columns" key={Math.random() + index}>
        {items.map((item) => {
          if (item.isLojaPadraoAssinante === true) {
            lojaService.setLojaPadrao(item);
            dispatch(ActionCreators.setLoja(item));
          }
          return (
            <Loja
              key={item.uuid + index}
              isPadrao={item.isLojaPadraoAssinante}
              item={item}
              onExcluir={(uuid) => setMinhasLojas((prev) => prev.filter((l) => l.uuid !== uuid))}
            />
          );
        })}
      </div>
    );
  });

  const callbackModal = () => {
    if (erro.isWrong === true) {
      setErro({ isWrong: false });
    }
  };

  const callbackModalSucesso = () => {
    dispatch(ActionCreators.showModal(false));
    if (sucesso.isSuccess === true) {
      setSucesso({ isSuccess: false });
    }
  };

  const goToAddNewLojaPage = () => {
    dispatch(ActionCreators.showModal(false));
    history.push("/configuracoes/loja/nova");
  };

  return (
    <>
      {erro.isWrong === true ? (
        <Modal
          callbackModal={callbackModal}
          visivel={erro !== null}
          titulo={erro.titulo}
          conteudo={erro.mensagem}
        />
      ) : null}
      {sucesso.isSuccess === true ? (
        <Modal
          callbackModal={callbackModalSucesso}
          visivel={sucesso !== null}
          titulo={sucesso.titulo}
          conteudo={sucesso.mensagem}
        />
      ) : null}
      <div className="page-container-style">
        <MinhasLojasPageStyle>
          <LojaContainerStyle>
            <h1>Minhas Lojas</h1>
            {todasaslojas}
            <button onClick={goToAddNewLojaPage} className="button btn-add-loja">
              Adicionar Loja
            </button>
          </LojaContainerStyle>
        </MinhasLojasPageStyle>
      </div>
    </>
  );
}

export default MinhasLojas;
